<template>
  <editable-control-wrapper
    :value="value"
    :has-label="floatingLabel"
    class="EditableControlFreeFormDatePicker"
  >
    <form-field
      :validator="validator"
      :attribute="attribute"
      :label="label"
      :hide-label="hideLabel"
      :name="name"
    >
      <div class="EditableControlFreeFormDatePicker__InputWrapper is-inline-flex is-aligned-middle">
        <input
          ref="input"
          v-model="computedValue"
          :placeholder="placeholder"
          class="input EditableControlFreeFormDatePicker__DateInput"
          type="text"
        >
        <el-date-picker
          class="EditableControlFreeFormDatePicker__DatePicker is-cursor-pointer"
          type="date"
          value-format="dd MM yyyy"
          @input="computedValue = $event"
        />
      </div>
    </form-field>
  </editable-control-wrapper>
</template>

<script>
import EditableControlPrototype from '@hypefactors/shared/js/components/forms/controls/EditableControlPrototype'

/**
 * Renders a free to edit input with optional DatePicker
 * @module EditableControlFreeFormDatePicker
 */
export default {
  name: 'EditableControlFreeFormDatePicker',
  mixins: [EditableControlPrototype]
}
</script>

<style lang="scss">
.EditableControlFreeFormDatePicker {
  &__DatePicker {
    width: 25px !important;
    height: 25px !important;

    .el-input__inner {
      display: none;
    }

    .el-input__prefix {
      top: 0;
      left: 0;
    }

    .el-input__icon {
      line-height: 1;
    }
  }
}
</style>
